import hotelcss from './css/hotelhotellist.module.css';
import React, { createElement } from "react"
import { useNavigate } from 'react-router-dom'
import { useParams } from "react-router-dom";
import { useState } from 'react';
import { useEffect } from 'react';
import Moment from 'moment';
import { setErrorMessage, setMessage, clearMessage } from "../tools/errorhandling";

import {
    getlinkedtasks, getCleaningtasks, getMyLinkedhotels, getAllhotelsForAdministrator, getAllHotelData, gethotelcleaners, saveCleaningassignment, updateCleaningassignment, deleteCleaningassignment, gettotalplanned,
    insertemployeetorooster, getCleaningADtasks, myData
} from "../dbconnector/connector";

import './css/tabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Button from 'react-bootstrap/Button';
import AssignmentDetail from '../customNodes/AssignmentDetail';
import DefaultAssignmentDetail from '../customNodes/DefaultAssignmentDetail';
import FocusOfTheDay from '../customNodes/FocusOfTheDay';
import DeleteReason from '../customNodes/DeleteReason';
import { RotatingLines } from "react-loader-spinner";
import { GoDotFill } from "react-icons/go";
import { GoDot } from "react-icons/go";
import { BsFillMoonStarsFill } from "react-icons/bs";



const AssignCleaningTasks = (props) => {

    const t = props.translation
    const [linkedhotels, setLinkedHotels] = useState({});
    const [roostersapproved, setRoosterapproved] = useState({});
    const [hotelassignments, sethotelassignments] = useState({});
    const [user, setUser] = useState({});
    const [planned, setPlanned] = useState({});
    const [hoteldata, setHoteldata] = useState({});
    const [hotelkamers, setHoteldKamers] = useState({});
    const [scheduledcleaners, setScheduleCleaners] = useState({});
    const [tabs, setTabs] = useState([]);
    const [selectedtab, setSelectedtab] = useState(-1);
    const [tabpanels, setTabPanels] = useState([]);
    const [tabpanelscontent, setTabPanelscontent] = useState([]);
    const [createAssignmentdiv, setCreateAssignmentdiv] = useState([]);
    const [cleaningtaskstoassignarray, setcleaningtaskstoassignarray] = useState([]);
    const [hotelcleanersarray, sethotelcleanersarray] = useState([]);
    const [hotelcleaners, sethotelcleaners] = useState([]);

    const [cleaningtypesarray, setcleaningtypesarray] = useState([]);
    const [cleaningtaskarray, setcleaningtaskarray] = useState([]);
    const [cleaningtask, setcleaningtask] = useState({});

    const [cleaningtaskADarray, setcleaningtaskADarray] = useState([]);
    const [cleaningtaskAD, setcleaningtaskAD] = useState({});

    const [cleaningtypes, setcleaningtypes] = useState([]);
    const [roomsettings, setRoomsettings] = useState([]);
    const [selectedCleaner, setSelectedCleaner] = useState(undefined);

    const [cleaningassignment, setCleaningassignment] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [assignmentDisabled, setassignmentDisabled] = useState(false);
    const prevCSS = React.useRef(0)
    const prevSelectedRecord = React.useRef(0)
    let { id } = useParams();
    const navigate = useNavigate()
    const [scheduledEmployees, setScheduledEmployees] = useState([]);
    const [totalshotel, setTotalhotel] = useState([]);
    const [hotelblijvers, sethotelBlijvers] = useState([]);
    const [hotelvertrekkers, sethotelVertrekkers] = useState([]);
    const [hotelflits, sethotelFlits] = useState([]);
    const [hotelspecialrequest, sethotelspecialrequest] = useState([]);
    const [hotelalgemenedienst, sethotelalgemenedienst] = useState([]);
    const [errorbuild, seterrorbuild] = useState("");
    const [extraTasksState, setExtraTasksState] = useState({});
    const [extraTasksStateDuration, setExtraTasksStateDuration] = useState(0);
    const [isAD, setIsAD] = useState(0);
    const [objectofhotelscleaners, setobjectofhotelscleaners] = useState({});
    const [notscheduledemployees, setNotscheduledemployees] = useState([]);

    const [cleaningtaskitems, setCleaningtaskitems] = useState([]);
    const [selectedroosterdate, setselectedroosterdate] = useState(new Date().toLocaleDateString("en-CA"));
    const [cleaningtaskADitems, setCleaningtaskADitems] = useState([]);
    const [Selectedhotel, setSelectedhotel] = useState([]);
    const [SelectedhotelObject, setSelectedhotelObject] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [dragwindow, setDragWindow] = useState(false);
    const [windowtodrag, setWindowtodrag] = useState(null);
    const [left, setleft] = useState(0);
    const [top, settop] = useState(0);

    const optionstypes = {
        0: t("Blijver"),
        1: t("Vertrekker"),
        2: t("Flitskamer"),
        3: t("dailyclean"),
        4: t("weeklyClean"),
        5: t("finalClean")
    };

    useEffect(() => {

        document.getElementById("FullscreenBlocker").style.display = "none";
        document.getElementById("RotatinglinesText").innerText = "data wordt opgehaald/verwerkt, even geduld"

        const mindate = Moment(new Date(), 'yyyy-MM-DD')
            .utc()
            .format('yyyy-MM-DD');
        const maxdate = Moment(new Date(), 'yyyy-MM-DD').add(1, "days").utc()
            .format('yyyy-MM-DD');

        let DateSession = Moment(new Date(sessionStorage.getItem('selectedDateforTasks')))
            .utc()
            .format('yyyy-MM-DD');

        if (DateSession < mindate) {
            DateSession = mindate
        }
        if (DateSession > maxdate) {
            DateSession = maxdate
        }
        if (sessionStorage.getItem('selectedDateforTasks') !== null && sessionStorage.getItem('selectedDateforTasks').length > 0) {
            document.getElementById("selectedDateforTasks").value = DateSession
            setselectedroosterdate(DateSession)
        } else {
            sessionStorage.setItem('selectedDateforTasks', mindate)
        }
        if (selectedroosterdate !== undefined) {
            try {
                setTabPanelscontent([])
                setLinkedHotels({})
                cleararray();
                if (props.rights === 2) {
                    const response = getAllhotelsForAdministrator(sessionStorage.getItem('selectedDateforTasks'))
                    response.then(res => {
                        if (res.status === 200) {
                            res.json().then(linkedhotels => {
                                //console.log("data: ", linkedhotels)
                                sethotelassignments(linkedhotels.planned)
                                setRoosterapproved(linkedhotels.roosterapproved)
                                setLinkedHotels(linkedhotels.hotels)
                            })
                        } else {
                            document.getElementById("CancelMessageButton").style.display = "none"
                            setMessage(res.statusText)
                        }
                    })
                } else {
                    const response = getMyLinkedhotels(sessionStorage.getItem('selectedDateforTasks'))
                    response.then(res => {
                        if (res.status === 200) {
                            res.json().then(linkedhotels => {
                                sethotelassignments(linkedhotels.planned)
                                setRoosterapproved(linkedhotels.roosterapproved)
                                setLinkedHotels(linkedhotels.hotels)
                            })
                        } else {
                            document.getElementById("CancelMessageButton").style.display = "none"
                            setMessage(res.statusText)
                        }
                    })
                }
            } catch (e) {
                setErrorMessage(t("error_retreivingData"))
            }
        }
        getMyData()
    }, []);


    const getMyData = async () => {
        myData().then(res => {
            if (res) {
                setUser({ ...res })
                // const linkedhotels = getLinkedhotels(res.id)
                // linkedhotels.then(res => {
                //////console.log("mydata", res)
                //   res.json().then(res => {
                //     //////console.log(res)
                //     setLinkedhotels(res)
                //   })
                // })

            }
        })
    }
    useEffect(() => {
        if (linkedhotels.length > 0) {
            buildtabs(linkedhotels, null, false);;
            const tabstorage = sessionStorage.getItem('selectedtabid')
            if (tabstorage !== undefined && tabstorage !== null) {
                setSelectedtab(Number(tabstorage))
            } else {
                setSelectedtab(0)
            }
        };

    }, [linkedhotels]);

    useEffect(() => {
        ////////console.log("linkedhotels", sessionStorage.getItem('selectedhotelId'))
        if (linkedhotels.length > 0) {
            const selectedhotelid = sessionStorage.getItem('selectedhotelId')
            if (selectedtab !== undefined && selectedtab !== null && sessionStorage.getItem('selectedhotelId') !== null) {

                setselectedtab(Number(selectedtab), linkedhotels.find((hotel) => hotel.Hotel_ID === Number(sessionStorage.getItem('selectedhotelId'))), null, false)
            } else {
                setselectedtab(Number(selectedtab), linkedhotels[0], null, false)
            }
        }

    }, [selectedtab]);


    const rebuildTabs = () => {
        cleararray();
        refresh_approvedlist(document.getElementById("selectedDateforTasks").value)
        sessionStorage.setItem('selectedDateforTasks', document.getElementById("selectedDateforTasks").value)
        setselectedroosterdate(document.getElementById("selectedDateforTasks").value)
        buildassignments(selectedCleaner, SelectedhotelObject, false, notscheduledemployees)
    }
    const refresh_approvedlist = (date) => {
        if (props.rights === 2) {
            const response = getAllhotelsForAdministrator(date)
            response.then(res => {
                if (res.status === 200) {
                    res.json().then(linkedhotels => {
                        setRoosterapproved(linkedhotels.roosterapproved)
                        linkedhotels.hotels.forEach((hotel, index) => {
                            if (document.getElementById('GoDotFill_' + hotel.hotel_Id) !== null) {
                                if (linkedhotels.roosterapproved[hotel.hotel_Id].length > 0 && linkedhotels.roosterapproved[hotel.hotel_Id][0].approved > 0) {
                                    document.getElementById('GoDotFill_' + hotel.hotel_Id).style.visibility = 'visible'
                                } else {
                                    document.getElementById('GoDotFill_' + hotel.hotel_Id).style.visibility = 'hidden'
                                }
                            }
                            if (document.getElementById('GoDot_' + hotel.hotel_Id) !== null) {
                                ////console.log("linkedhotels.planned[hotel.hotel_Id][0].total :", linkedhotels.planned[hotel.hotel_Id][0].total)
                                if (linkedhotels.planned[hotel.hotel_Id].length > 0 && linkedhotels.planned[hotel.hotel_Id][0].total > 0) {
                                    document.getElementById('GoDot_' + hotel.hotel_Id).style.visibility = 'visible'
                                } else {
                                    document.getElementById('GoDot_' + hotel.hotel_Id).style.visibility = 'hidden'
                                }
                            }

                        })
                    })
                } else {
                    document.getElementById("CancelMessageButton").style.display = "none"
                    setMessage(res.statusText)
                }
            })
        } else {
            const response = getMyLinkedhotels(date)
            response.then(res => {
                if (res.status === 200) {
                    res.json().then(linkedhotels => {
                        setRoosterapproved(linkedhotels.roosterapproved)
                        linkedhotels.hotels.forEach((hotel, index) => {
                            if (document.getElementById('GoDotFill_' + hotel.hotel_Id) !== null) {
                                if (linkedhotels.roosterapproved[hotel.hotel_Id].length > 0 && linkedhotels.roosterapproved[hotel.hotel_Id][0].approved > 0) {
                                    document.getElementById('GoDotFill_' + hotel.hotel_Id).style.visibility = 'visible'
                                } else {
                                    document.getElementById('GoDotFill_' + hotel.hotel_Id).style.visibility = 'hidden'
                                }
                            }
                            if (document.getElementById('GoDot_' + hotel.hotel_Id) !== null) {
                                if (linkedhotels.planned[hotel.hotel_Id].length > 0 && linkedhotels.planned[hotel.hotel_Id][0].total > 0) {
                                    document.getElementById('GoDot_' + hotel.hotel_Id).style.visibility = 'visible'
                                } else {
                                    document.getElementById('GoDot_' + hotel.hotel_Id).style.visibility = 'hidden'
                                }
                            }
                        })
                    })
                } else {
                    document.getElementById("CancelMessageButton").style.display = "none"
                    setMessage(res.statusText)
                }
            })
        }

    }

    const buildassignments = (employee_id, hotel, noCleaning, notscheduledemployees) => {

        if (hotel.Hotel_ID !== undefined) {
            setScheduleCleaners({})
            setHoteldKamers({})
            document.getElementById("FullscreenBlocker").style.display = "block";
            document.getElementById("RotatinglinesText").innerText = "Ophalen gegevens even geduld"

            getAllHotelData(document.getElementById("selectedDateforTasks").value, hotel.Hotel_ID).then(res => {
                if (res.status === 200) {
                    res.json().then(data => {
                        //////console.log("data :", data)
                        setHoteldKamers(data.hotels[0].kamers)
                        setScheduleCleaners(data.plannedEMP)
                        buildtabcontent(hotel, data.plannedEMP, data, employee_id, noCleaning, notscheduledemployees, data.hotels[0].kamers)
                    })
                } else {
                    setErrorMessage(res.statusText)
                    document.getElementById("FullscreenBlocker").style.display = "none";
                }
            });

        }
    }
    useEffect(() => {

        if (linkedhotels.length > 0) {
            let iselectedtab = selectedtab
            if (selectedtab < 0) {
                iselectedtab = 0
            }
            const hotel = linkedhotels[iselectedtab]
            setScheduleCleaners({})
            document.getElementById("FullscreenBlocker").style.display = "block";
            document.getElementById("RotatinglinesText").innerText = "Ophalen gegevens even geduld"


            getAllHotelData(selectedroosterdate, hotel.Hotel_ID).then(res => {
                if (res.status === 200) {
                    res.json().then(data => {
                        setScheduleCleaners(data.plannedEMP)
                    })
                    document.getElementById("FullscreenBlocker").style.display = "none";
                } else {
                    setErrorMessage(res.statusText)
                    document.getElementById("FullscreenBlocker").style.display = "none";
                }
            });
        }
    }, [linkedhotels, selectedroosterdate])

    useEffect(() => {
        buildassignments(selectedCleaner, SelectedhotelObject, false, notscheduledemployees)
    }, [notscheduledemployees, SelectedhotelObject, selectedCleaner])

    useEffect(() => {
        if (document.getElementById("cleaningtype") != null)
            showAssignedCleaningTasks(document.getElementById("cleaningtype").value);
    }, [createAssignmentdiv]);


    const setselectedtab = (tabid, hotel, employee_id, noCleaning) => {
        cleararray();
        if (hotel !== undefined && hotel.hotel_Id !== undefined) {
            setSelectedEmployee(employee_id)
            setSelectedhotelObject(hotel)
            getTotalplanned(hotel)
            setSelectedtab(tabid)
            sessionStorage.setItem('selectedtabid', tabid)
            sessionStorage.setItem('selectedhotelId', hotel.hotel_Id)
        }
    }
    const getTotalplanned = (hotel) => {
        gettotalplanned(hotel.hotel_Id, selectedroosterdate).then(res => {
            if (res.status === 200) {
                res.json().then(res => {
                    if (totalshotel.find(({ key }) => key === res.hotel_Id) === undefined) {
                        setTotalhotel(res => [...res, { key: res.hotel_Id, data: { blijver: res.blijver, vertrekker: res.vertrekker, AD: res.AD } }])
                    }
                })
            } else if (res.status === 204) {
                // if (document.getElementById("CancelMessageButton") !== null) {
                //     document.getElementById("CancelMessageButton").style.display = "none"
                //     setErrorMessage(t("error_noAvailableSchedule"))
                // }
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }

    const buildtabcontent = (hotel, cleaners, assignments, employee_id, noCleaning, notscheduledemployees, kamers) => {
        /////console.log("kamers", kamers)
        setTabPanelscontent([])
        const hoteldata = hotel
        setTabPanelscontent(pre => [...pre,
        <div className="tabpanel" key={"div" + hoteldata.hotel_Id} id={"tabpanel" + hoteldata.hotel_Id}>
            <div className="UserTabforTasks" id={"hoteltab_id_top" + hoteldata.hotel_Id}>
                <div id={"hoteltab_id_" + hoteldata.hotel_Id}>
                    {GetScheduledCleaners(cleaners[hoteldata.hotel_Id], hoteldata.hotel_Id, kamers, assignments, employee_id)}
                    <br></br>
                    <select id="AddCleanertoSchedule" className='scheduleRoosterGeneral' onFocus={() => SetNonSelectedEmplyees(assignments, hotel)} onChange={e => handleSelectNewCleaner(e, hoteldata.hotel_Id)} style={selectedroosterdate > new Date().toLocaleDateString("en-CA") ? { display: "block" } : { display: "block" }}>
                        <option>{t('Add Employee')}</option>
                    </select>
                </div>
                <div id={hoteldata.hotel_Id + "_Roomtab"}>
                    <div className="RoomTabs" key={hoteldata.hotel_Id + "_1"}>
                        {buildkamerpanels(kamers, hoteldata.hotel_Id, assignments, employee_id, noCleaning)}
                    </div>
                    <label className='DefaultAssignmentsTitle' key={hoteldata.hotel_Id + "_2"}>{t('Specifieketaken')}</label>
                    <div className="DefaultAssignmentTabs" key={hoteldata.hotel_Id + "_3"}>
                        {buildDefaultassignmentspanels(hoteldata.hotel_Id, assignments.defaults, employee_id, assignments.plannedEMP)}
                    </div>
                    <br key={hoteldata.hotel_Id + "_4"}></br>
                    <Button id="CreatedefaultCT" key={hoteldata.hotel_Id + "_CreatedefaultCT"} className="Savebutton btn btn-primary margin-right lightgreenTextColor" onClick={() => CreateDefaultCleaningassignment(hoteldata.hotel_Id, undefined, assignments.plannedEMP)}>{t('Maakspecifieketaak')}</Button>
                </div>
            </div>
        </div>
        ])
        document.getElementById("FullscreenBlocker").style.display = "none";
    }

    const buildtabs = (assignments, employee_id, noCleaning) => {
        setTabs([])
        cleararray();
        if (linkedhotels.length > 0) {
            linkedhotels.forEach((hotel, index) => {

                document.getElementById("RotatinglinesText").innerText = "Ophalen gegevens hotel " + hotel.name + ", even geduld"
                let approved = 0;
                if (roostersapproved[hotel.hotel_Id].length > 0) {
                    approved = roostersapproved[hotel.hotel_Id][0].approved
                }
                let planned = 0;
                if (hotelassignments[hotel.hotel_Id].length > 0) {
                    planned = 1
                }
                ////////console.log("roostersapproved ", approved)
                //let approved = roostersapproved
                setTabs(pre => [...pre,
                <Tab id={'"' + hotel.hotel_Id + '"'} key={'"' + hotel.hotel_Id + '"'} onClick={() => setselectedtab(index, hotel, assignments, employee_id, noCleaning)} >{hotel.nr_afd} - {hotel.Name} <GoDotFill id={'GoDotFill_' + hotel.hotel_Id} style={approved === 1 ? { visibility: "visible" } : { visibility: 'hidden' }} /><GoDot id={'GoDot_' + hotel.hotel_Id} style={planned === 1 ? { visibility: "visible" } : { visibility: 'hidden' }} /></Tab>
                ])
            })
        }
        document.getElementById("FullscreenBlocker").style.display = "none";

    }
    const cleararray = () => {
        scheduledEmployees.forEach(user => {
            user.data.assignedvalue = 0
        })
        hotelblijvers.forEach(hotel => {
            hotel.data.assignedvalue = 0
        })
        hotelvertrekkers.forEach(hotel => {
            hotel.data.assignedvalue = 0
        })
        hotelflits.forEach(hotel => {
            hotel.data.assignedvalue = 0
        })
        hotelalgemenedienst.forEach(hotel => {
            hotel.data.assignedvalue = 0
        })
        hotelspecialrequest.forEach(hotel => {
            hotel.data.assignedvalue = 0
        })
    }
    const fillHotelTotals = (id, hotel_id, value) => {
        if (id === "blijver") {
            if (hotelblijvers.find(({ key }) => key === hotel_id) === undefined) {
                hotelblijvers.push({ key: hotel_id, data: { assignedvalue: value } })
            } else {
                let newvalue = hotelblijvers.find(({ key }) => key === hotel_id).data.assignedvalue + value
                hotelblijvers.find(({ key }) => key === hotel_id).data = { assignedvalue: newvalue }
            }
        }
        if (id === "vertrekker") {
            if (hotelvertrekkers.find(({ key }) => key === hotel_id) === undefined) {
                hotelvertrekkers.push({ key: hotel_id, data: { assignedvalue: value } })
            } else {
                let newvalue = hotelvertrekkers.find(({ key }) => key === hotel_id).data.assignedvalue + value
                hotelvertrekkers.find(({ key }) => key === hotel_id).data = { assignedvalue: newvalue }
            }
        }
        if (id === "flits") {
            if (hotelflits.find(({ key }) => key === hotel_id) === undefined) {
                hotelflits.push({ key: hotel_id, data: { assignedvalue: value } })
            } else {
                let newvalue = hotelflits.find(({ key }) => key === hotel_id).data.assignedvalue + value
                hotelflits.find(({ key }) => key === hotel_id).data = { assignedvalue: newvalue }
            }
        }
        if (id === "specialrequest") {
            if (hotelspecialrequest.find(({ key }) => key === hotel_id) === undefined) {
                hotelspecialrequest.push({ key: hotel_id, data: { assignedvalue: value } })
            } else {
                let newvalue = hotelspecialrequest.find(({ key }) => key === hotel_id).data.assignedvalue + value
                hotelspecialrequest.find(({ key }) => key === hotel_id).data = { assignedvalue: newvalue }
            }
        }
        if (id === "AD") {
            if (hotelalgemenedienst.find(({ key }) => key === hotel_id) === undefined) {
                hotelalgemenedienst.push({ key: hotel_id, data: { assignedvalue: value } })
            } else {
                let newvalue = hotelalgemenedienst.find(({ key }) => key === hotel_id).data.assignedvalue + value
                hotelalgemenedienst.find(({ key }) => key === hotel_id).data = { assignedvalue: newvalue }
            }
        }
    }
    const fillEmployeeAssignments = (assignment) => {
        let returnValue = 60 / assignment.timeneeded
        if (scheduledEmployees.find(({ key }) => key === assignment.assignee_Id) === undefined) {
            scheduledEmployees.push({ key: assignment.assignee_Id, data: { assignedvalue: returnValue } })
        } else {
            let newvalue = scheduledEmployees.find(({ key }) => key === assignment.assignee_Id).data.assignedvalue + returnValue
            scheduledEmployees.find(({ key }) => key === assignment.assignee_Id).data = { assignedvalue: newvalue }
        }
    }
    const getEmployeeTotal = (employee_Id) => {
        let calculatedhours = "0"
        if (scheduledEmployees.find(({ key }) => key === employee_Id) !== undefined) {
            let time = scheduledEmployees.find(({ key }) => key === employee_Id).data.assignedvalue
            var Hours = Math.floor(time / 60)
            var minutes = time % 60
            calculatedhours = Hours + "h" + minutes
        }

        return calculatedhours
    }
    const buildkamerpanels = (kamers, hotel_Id, assignments, cleanerid, disabledvalue) => {
        cleararray()
        document.getElementById("FullscreenBlocker").style.display = "block";
        document.getElementById("RotatinglinesText").innerText = "Ophalen gegevens even geduld"
        document.getElementById("assignmentdetails").style.display = "none"
        document.getElementById("Defaultassignmentdetails").style.display = "none"
        document.getElementById("focusOftheDay").style.display = "none"
        document.getElementById("deletReason").style.display = "none"
        document.getElementById("coverAll").style.display = "none"
        let kamerpanels = [];
        //////////console.log("kamers", kamers)
        if (kamers !== undefined && kamers.length > 0) {
            kamers.forEach(kamer => {
                //console.log("kamer ",kamer)
                if (kamer.kamerNummer != "No rooms") {
                    let ButClassName = "CleaningTypeButton"
                    let roomassignment = undefined;
                    if (assignments.assignments[hotel_Id].find(assignment => assignment.roomnumber === kamer.kamerNummer) !== undefined) {
                        roomassignment = assignments.assignments[hotel_Id].find(assignment => assignment.roomnumber === kamer.kamerNummer)
                    }
                    if (assignments.specialAssignments[hotel_Id].find(assignment => assignment.roomnumber === kamer.kamerNummer) !== undefined) {

                        roomassignment = assignments.specialAssignments[hotel_Id].find(assignment => assignment.roomnumber === kamer.kamerNummer)
                    }
                    if (roomassignment === undefined) {
                        ButClassName = "CleaningTypeButton"
                    } else {
                        fillEmployeeAssignments(roomassignment)
                        if (roomassignment.cleaningtype_type === 0) {
                            fillHotelTotals("blijver", hotel_Id, 1)
                        } else if (roomassignment.cleaningtype_type === 1) {
                            fillHotelTotals("vertrekker", hotel_Id, 1)
                        }
                        else if (roomassignment.cleaningtype_type === 2) {
                            fillHotelTotals("flits", hotel_Id, 1)
                        } else if (roomassignment.cleaningtype_type === -2) {
                            fillHotelTotals("specialrequest", hotel_Id, 1)
                        }

                        if (cleanerid === roomassignment.assignee_Id && roomassignment.status !== 8) {
                            if (roomassignment.cleaningtype_type === 0) {
                                ButClassName = "CleaningTypeButton CleaningTypeButton_status" + roomassignment.status + " Add_border"
                            } else if (roomassignment.cleaningtype_type === 1) {
                                ButClassName = "CleaningTypeButton CleaningTypeButton_status" + roomassignment.status + " Add_border_vertrekker"
                            } else if (roomassignment.cleaningtype_type === 2) {
                                ButClassName = "CleaningTypeButton CleaningTypeButton_status" + roomassignment.status + " Add_border_flits"
                            } else if (roomassignment.cleaningtype_type === -2) {
                                ButClassName = "CleaningTypeButton CleaningTypeButton_status" + roomassignment.status + " Add_border_specialrequest"
                            }
                        }
                        else {
                            ButClassName = "CleaningTypeButton CleaningTypeButton_status" + roomassignment.status
                        }
                    }
                    kamerpanels.push(
                        <Button id={hotel_Id + "." + kamer.kamerNummer} key={hotel_Id + "." + kamer.kamerNummer} className={ButClassName} onClick={() => Createcleaningassignment(kamer, hotel_Id, roomassignment, assignments.plannedEMP)} disabled={disabledvalue}><center>
                            <div>{kamer.kamerNummer}</div>
                            {/* <div className='kamertypenaam'>{kamer.kamerTypeNaam}</div>
                        <div ><PiUser />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<MdCleaningServices /></div> */}
                        </center>
                        </Button>
                    )
                } else {
                    kamerpanels.push(
                        <div className="NoRoomsLinked" key={hotel_Id + "." + kamer.kamerNummer}><center>
                            {t("NoRoomsdefined")}
                        </center>
                        </div>)
                }
            });
        }
        document.getElementById("FullscreenBlocker").style.display = "none";
        return kamerpanels
    }

    const buildDefaultassignmentspanels = (hotel_Id, defaults, cleanerid, plannedEMP) => {
        document.getElementById("FullscreenBlocker").style.display = "block";
        document.getElementById("RotatinglinesText").innerText = "Ophalen gegevens even geduld"
        document.getElementById("assignmentdetails").style.display = "none"
        document.getElementById("Defaultassignmentdetails").style.display = "none"
        document.getElementById("focusOftheDay").style.display = "none"
        document.getElementById("coverAll").style.display = "none"
        let kamerpanels = [];
        let ButClassName = "CleaningTypeButton"
        if (defaults[hotel_Id]) {
            if (defaults[hotel_Id].length > 0) {
                defaults[hotel_Id].forEach(defaultassignment => {
                    if (defaultassignment === undefined) {
                        ButClassName = "DefaultAssignmentButton"
                    } else {
                        fillEmployeeAssignments(defaultassignment)
                        fillHotelTotals("AD", hotel_Id, 1)
                        if (cleanerid === defaultassignment.assignee_Id) {
                            ButClassName = "DefaultAssignmentButton CleaningTypeButton_status" + defaultassignment.status + " Add_border"
                        }
                        else {
                            ButClassName = "DefaultAssignmentButton CleaningTypeButton_status" + defaultassignment.status
                        }
                    }
                    kamerpanels.push(
                        <Button id={hotel_Id + "." + defaultassignment.id} key={hotel_Id + "." + defaultassignment.id} className={ButClassName} onClick={() => CreateDefaultCleaningassignment(hotel_Id, defaultassignment, plannedEMP)}><center>
                            <div className='assignmenttitle'>{defaultassignment.title}</div>
                            {/* <div className='kamertypenaam'>{defaultassignment.achternaam}, {defaultassignment.voornaam}</div>
                        <div ><PiUser />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<MdCleaningServices /></div> */}
                        </center>
                        </Button>
                    )
                });
            }
        }
        else {
            kamerpanels.push(
                <div className="NoRoomsLinked doublegrid" key={hotel_Id + "_nospecifictasks"}><center>
                    Er zijn momenteel geen specifieke taken lopende
                </center>
                </div>)
        }
        document.getElementById("FullscreenBlocker").style.display = "none";
        return kamerpanels
    }

    const handleCancel = () => {
        setassignmentDisabled(true)
        document.getElementById("assignmentdetails").style.display = "none"
        document.getElementById("Defaultassignmentdetails").style.display = "none"
        document.getElementById("focusOftheDay").style.display = "none"
        document.getElementById("deletReason").style.display = "none";
        document.getElementById("coverAll").style.display = "none"
    }
    // cleaningTypeDescription comes from an unordered GROUP_CONCAT, so look the type up by id, not by position
    const getCleaningTypeNorm = (cleaningtype_Id) => {
        const cleaningtype = roomsettings.cleaningTypeDescription.find(item => Number(item.id) === Number(cleaningtype_Id))
        return cleaningtype ? cleaningtype.norm : undefined
    }

    const handlCreateAssignment = async () => {
       // await calculateExtraTasksDuration()

        document.getElementById("FullscreenBlocker").style.display = "Block";
        document.getElementById("RotatinglinesText").innerText = "taak wordt aangemaakt, even geduld"
        const title = document.getElementById("roomnumber").value + " " + document.getElementById("roomtype").value
        let uptodatecleaning;
        await setCleaningassignment(pre => {
            uptodatecleaning = pre
            return pre
        })
        if (uptodatecleaning.extratime.length === 0)
            uptodatecleaning.extratime = 0

        const extratasks = await getExtraTasksObject()


        if ((uptodatecleaning.cleaningtype_Id && uptodatecleaning.cleaningtype_Id !== -1) && (uptodatecleaning.assignee_Id && Number(uptodatecleaning.assignee_Id) !== -1)) {
            uptodatecleaning.creationdate = selectedroosterdate
            uptodatecleaning.timeneeded = extratasks.duration
            uptodatecleaning.tasks = extratasks.tasks.toString()
            uptodatecleaning.norm = getCleaningTypeNorm(uptodatecleaning.cleaningtype_Id)
            uptodatecleaning.multiple = JSON.stringify(extratasks.multiple)
            console.log("norm =", Number(uptodatecleaning.norm))
            console.log("calculatedcleaningtime",  Number(extratasks.calculatedcleaningtime))
            uptodatecleaning.calculatedcleaningtime = (Number((60 / Number(uptodatecleaning.norm))) + Number(extratasks.calculatedcleaningtime))
            //console.log("uptodatecleaning = ", uptodatecleaning)
            const response = saveCleaningassignment({ ...uptodatecleaning, title: title, roomnumber: document.getElementById("roomnumber").value })

            response.then(res => {
                if (res.status === 200) {
                    document.getElementById("assignmentdetails").style.display = "none"
                    document.getElementById("coverAll").style.display = "none"
                    document.getElementById("CancelMessageButton").style.display = "none"
                    setMessage(t('CleaningTaskforroom') + document.getElementById("roomnumber").value + t('hasbeencreated'))
                    rebuildTabs()
                    document.getElementById("FullscreenBlocker").style.display = "none";
                } else {
                    setErrorMessage(res.statusText)
                    document.getElementById("FullscreenBlocker").style.display = "none";
                }
            }
            )
        } else {
            setMessage(t("error_nocleaningtype_selected"))
            document.getElementById("FullscreenBlocker").style.display = "none";
        }
    }


    const handleCheckboxChange = (taskId, index, checked, assignment) => {
        const value = Number(document.getElementById("multiple"+ taskId).value)
        let calcduration = Number(assignment.taskDuration) / value

        console.log(value)
        console.log(Number(assignment.taskDuration))
        console.log(calcduration)
        setExtraTasksStateDuration(prev => ({
            ...prev,
            [taskId]: calcduration
        }));


        setExtraTasksState(prev => {
            const newTasks = { ...prev };
            if (checked) {
                newTasks[taskId] = value;
            } else {
                delete newTasks[taskId];
            }
            return newTasks;
        });
        
    };
    const getExtraTasksObject = async () => {
       console.log(extraTasksState)
        let durationcalc = 0
        Object.keys(extraTasksState).forEach((key) => {
            if( document.getElementById("interval" + key).checked)
                //console.log("calculation", Number(document.getElementById("interval" + key).value) , "*" ,  Number(document.getElementById("multiple" + key).value))
                durationcalc += ((60 / Number(document.getElementById("interval" + key).value)) * Number(document.getElementById("multiple" + key).value))
                //console.log("calculation result", durationcalc)
        })

        let object = {
            tasks: [],
            duration: 0,
            calculatedcleaningtime: durationcalc,
            multiple: {}
        };
        Object.keys(extraTasksState).forEach((key) => {
            object.tasks.push(key)
        })
        object.multiple = extraTasksState
        //console.log("object ", object)
        return object;
    };


    const handlCreateDefaultAssignment = async () => {
        document.getElementById("FullscreenBlocker").style.display = "Block";
        document.getElementById("RotatinglinesText").innerText = "Algemene diensttaak wordt aangemaakt, even geduld"
        let uptodatecleaning;
        await setCleaningassignment(pre => {
            uptodatecleaning = pre
            return pre
        })
        if (uptodatecleaning.id === "") {
            delete uptodatecleaning.id
        }
        if ((uptodatecleaning.assignee_Id && Number(uptodatecleaning.assignee_Id) !== -1) && (uptodatecleaning.extratime && Number(uptodatecleaning.extratime) !== -1)) {
            const extratasks = await getExtraTasksObject()
            console.log("extratasks",  JSON.stringify(extratasks.multiple))
            uptodatecleaning.timeneeded = extratasks.duration
            uptodatecleaning.creationdate = selectedroosterdate
            uptodatecleaning.tasks = extratasks.tasks.toString()
            uptodatecleaning.multiple = JSON.stringify(extratasks.multiple)
            uptodatecleaning.calculatedcleaningtime = (Number(uptodatecleaning.extratime) + Number(extratasks.calculatedcleaningtime))
            const response = saveCleaningassignment({ ...uptodatecleaning })
            response.then(res => {
                if (res.status === 200) {
                    document.getElementById("assignmentdetails").style.display = "none"
                    document.getElementById("coverAll").style.display = "none"
                    document.getElementById("CancelMessageButton").style.display = "none"
                    setMessage(t('DefaultCleaningCreated') + document.getElementById("title").value + t('hasbeencreated'))
                    rebuildTabs()
                    document.getElementById("FullscreenBlocker").style.display = "none";
                } else {
                    setErrorMessage(res.statusText)
                    document.getElementById("FullscreenBlocker").style.display = "none";
                }
            }
            )
        } else {
            setMessage(t("error_nocemployee_selected"))
            document.getElementById("FullscreenBlocker").style.display = "none";
        }
    }

    const handlUpdateDefaultAssignment = async (assignment_id) => {
        document.getElementById("FullscreenBlocker").style.display = "Block";
        document.getElementById("RotatinglinesText").innerText = "taak wordt aangepast, even geduld"
        let uptodatecleaning;
        await setCleaningassignment(pre => {
            uptodatecleaning = pre
            return pre
        })
        if ((uptodatecleaning.assignee_Id && Number(uptodatecleaning.assignee_Id) !== -1) && (uptodatecleaning.extratime && Number(uptodatecleaning.extratime) !== -1)) {
            delete uptodatecleaning.voornaam
            delete uptodatecleaning.achternaam
            delete uptodatecleaning.kamerType
            delete uptodatecleaning.type
            //delete uptodatecleaning.creationdate
            if (uptodatecleaning.extratime.length === 0) {
                uptodatecleaning.extratime = 0
            }
            const extratasks = await getExtraTasksObject()

            uptodatecleaning.timeneeded = extratasks.duration
            uptodatecleaning.tasks = extratasks.tasks.toString()
            uptodatecleaning.multiple = JSON.stringify(extratasks.multiple)
            uptodatecleaning.calculatedcleaningtime = (Number(uptodatecleaning.extratime) + Number(extratasks.calculatedcleaningtime))

            const response = updateCleaningassignment({ ...uptodatecleaning }, assignment_id)
            response.then(res => {
                if (res.status === 200) {
                    document.getElementById("assignmentdetails").style.display = "none"
                    document.getElementById("coverAll").style.display = "none"
                    document.getElementById("updateButton").style.display = "none"
                    //document.getElementById(hotel_Id + "." + document.getElementById("roomnumber").value).className = "CleaningTypeButton CleaningTypeButton_status0"
                    document.getElementById("CancelMessageButton").style.display = "none"
                    setMessage(t('DefaultCleaningCreated') + document.getElementById("title").value + t('hasbeenupdated'))

                    rebuildTabs()
                    document.getElementById("FullscreenBlocker").style.display = "none";
                } else {
                    setErrorMessage(res.statusText)
                    document.getElementById("FullscreenBlocker").style.display = "none";
                }
            }
            )
        } else {
            setMessage(t("error_nocemployee_selected"))
            document.getElementById("FullscreenBlocker").style.display = "none";
        }

    }

    const handlEditAssignment = async (assignment) => {
        setassignmentDisabled(false)
        document.getElementById("EditButton").style.display = "none"
        document.getElementById("saveButton").style.display = "none"
        document.getElementById("updateButton").style.display = "block"
    }

    const handlEditDefaultAssignment = async () => {
        setassignmentDisabled(false)
        document.getElementById("DefaultEditButton").style.display = "none"
        document.getElementById("DefaultsaveButton").style.display = "none"
        document.getElementById("DefaultupdateButton").style.display = "block"
    }

    const handlDeleteAssignment = async (assignment) => {
        ////console.log("assignment : ", assignment)
        const assignment_id = assignment.id
        if (assignment.status === 0) {
            document.getElementById("FullscreenBlocker").style.display = "Block";
            document.getElementById("RotatinglinesText").innerText = "taak wordt verwijderd, even geduld"
            const response = deleteCleaningassignment(assignment_id)
            response.then(res => {
                if (res.status === 200) {
                    document.getElementById("assignmentdetails").style.display = "none"
                    document.getElementById("coverAll").style.display = "none"
                    document.getElementById("updateButton").style.display = "none"
                    document.getElementById("CancelMessageButton").style.display = "none"
                    setMessage(t('CleaningTaskforroom') + document.getElementById("roomnumber").value + t('hasbeenremoved'))
                    rebuildTabs()
                    document.getElementById("FullscreenBlocker").style.display = "none";
                } else {
                    setErrorMessage(res.statusText)
                    document.getElementById("FullscreenBlocker").style.display = "none";
                }
            }
            )
        }
        else {
            document.getElementById("deletReason").style.display = "block";
            document.getElementById("deletReason").style.zIndex = document.getElementById("assignmentdetails").style.zIndex + 10
            document.getElementById("coverAll").style.display = "block";
        }
    }

    const handleDeleteAssignmentafterstartup = async () => {

        //handleOnchange({ target: { name: "deletedby", value: user.id } })
        setCleaningassignment(pre => ({ ...pre, deletedby: user.id }))
        setCleaningassignment(pre => ({ ...pre, deletedbyfullname: user.achternaam + ", " + user.voornaam }))
        setCleaningassignment(pre => ({ ...pre, status: 8 }))
        //deletedbyfullname
        handlUpdateAssignment(cleaningassignment.id)

        ////////console.log("assignment: ", cleaningassignment)
    }

    const ReSetAssignment = async (status) => {
        setCleaningassignment(pre => ({ ...pre, status: status }))
        handlUpdateAssignment(cleaningassignment.id)
    }

    const handlUpdateAssignment = async (assignment_id) => {
        //
        await calculateExtraTasksDuration()
        document.getElementById("FullscreenBlocker").style.display = "Block";
        document.getElementById("RotatinglinesText").innerText = "taak wordt aangepast, even geduld"
        const title = document.getElementById("roomnumber").value + " " + document.getElementById("roomtype").value
        let uptodatecleaning;
        await setCleaningassignment(pre => {
            uptodatecleaning = pre
            return pre
        })
        delete uptodatecleaning.voornaam
        delete uptodatecleaning.achternaam
        delete uptodatecleaning.type
        delete uptodatecleaning.kamerType
        if (uptodatecleaning.extratime.length === 0) {
            uptodatecleaning.extratime = 0
        }
        if ((uptodatecleaning.cleaningtype_Id && uptodatecleaning.cleaningtype_Id !== -1) && (uptodatecleaning.assignee_Id && Number(uptodatecleaning.assignee_Id) !== -1)) {
            const extratasks = await getExtraTasksObject()
            uptodatecleaning.timeneeded = extratasks.duration
            uptodatecleaning.tasks = extratasks.tasks.toString()
            uptodatecleaning.multiple = JSON.stringify(extratasks.multiple)

            uptodatecleaning.norm = getCleaningTypeNorm(uptodatecleaning.cleaningtype_Id)
            uptodatecleaning.calculatedcleaningtime = (Number((60 / Number(uptodatecleaning.norm))) + (Number(extratasks.calculatedcleaningtime) ? Number(extratasks.calculatedcleaningtime) : 0))

            const response = updateCleaningassignment({ ...uptodatecleaning, title: title, roomnumber: document.getElementById("roomnumber").value }, assignment_id)
            response.then(res => {
                if (res.status === 200) {
                    document.getElementById("assignmentdetails").style.display = "none"
                    document.getElementById("coverAll").style.display = "none"
                    document.getElementById("updateButton").style.display = "none"
                    if (uptodatecleaning.status !== 8) {
                        setMessage(t('CleaningTaskforroom') + document.getElementById("roomnumber").value + t('hasbeenupdated'))
                    } else {
                        setMessage(t('CleaningTaskforroom') + document.getElementById("roomnumber").value + t('hasbeendeleted'))
                    }
                    rebuildTabs()
                    document.getElementById("FullscreenBlocker").style.display = "none";
                } else {
                    setErrorMessage(res.statusText)
                    document.getElementById("FullscreenBlocker").style.display = "none";
                }
            }
            )
        } else {
            setMessage(t("error_nocleaningtype_selected"))
            document.getElementById("FullscreenBlocker").style.display = "none";
        }
    }

    const showAssignedCleaningTasks = async (e, cleaningtypeid) => {
        if (cleaningtypeid > -2) {
            handleOnchange({ target: { name: "cleaningtype_Id", value: cleaningtypeid } })
            const type = cleaningtypes.find((item) => item.id === cleaningtypeid);
            if (type !== undefined) {
                handleOnchange({ target: { name: "cleaningtype_type", value: type.type } })
            } else { handleOnchange({ target: { name: "cleaningtype_Id", value: -1 } }) }
        } else {
            handleOnchange({ target: { name: "cleaningtype_Id", value: -2 } })
            handleOnchange({ target: { name: "cleaningtype_type", value: -2 } })
        }
        const parentdiv = document.getElementById("cleaningtask");
        if (parentdiv != null) {
            parentdiv.innerText = "";
            const newUL = document.createElement("ul");
            newUL.id = "linkedcleaningtasks"
            newUL.name = "Name"
            parentdiv.appendChild(newUL)
        }

        const targetdiv = document.getElementById("linkedcleaningtasks");
        const response = await getlinkedtasks(cleaningtypeid);

        let description = "";
        if (response.status === 200) {
            const body = await response.json()
            if (targetdiv != null)
                targetdiv.innerHTML = "";

            body.items.forEach((item, index) => {
                const LI = document.createElement("li")
                description += item.taskDescription + "\n"
                LI.innerText = item.taskDescription
                LI.className = "ListItemCleaningTasks"
                if (targetdiv != null)
                    targetdiv.appendChild(LI)
            })
        }
        handleOnchange({ target: { name: "description", value: description } })
        return cleaningtaskstoassignarray
    }

    const handleOnchange = (e) => {
        ////console.log("e.target.name ", e.target.name)
        ////console.log(e.target.value)
        ////console.log("scheduledcleaners", scheduledcleaners)
        ////console.log("Selectedhotel", Selectedhotel)
        ////console.log("scheduledcleaners[Selectedhotel]", scheduledcleaners[Selectedhotel])
        if (e.target.name === "assignee_Id" && Number(e.target.value) > 0) {

            const cleaner = scheduledcleaners[Selectedhotel].find(emp => emp.werknemer_Id === Number(e.target.value))
            setCleaningassignment(pre => ({ ...pre, ["IsNightShift"]: cleaner.nightshift }))

        }
        setCleaningassignment(pre => ({ ...pre, [e.target.name]: e.target.value }))
    }
    const handleFocusOfftheday = (focusoftheday) => {
        setCleaningassignment(pre => ({ ...pre, ["extradescription"]: focusoftheday }))
    }
    // const removeobjectfromds = (e) => {
    //     delete cleaningassignment.cleaningtype_type
    // }

    const handleChangecheckbox = (e) => {
        setCleaningassignment(pre => ({ ...pre, [e.target.name]: e.target.checked }))
    }

    //TODO: niet reloaden als er 1 wordt toegevoegd.
    const handleaddNewUser = (userid, hotelid, datum) => {
        document.getElementById("FullscreenBlocker").style.display = "Block";
        document.getElementById("RotatinglinesText").innerText = "Teamlid wordt toegevoegd, even geduld"
        insertemployeetorooster(hotelid, userid, datum).then((res) => {
            if (res.status === 200) {
                rebuildTabs()
                document.getElementById("FullscreenBlocker").style.display = "none";
            } else {
                setErrorMessage(res.statusText)
                document.getElementById("FullscreenBlocker").style.display = "none";
            }
        })
    }

    const SetNonSelectedEmplyees = (hoteldata, hotel) => {
        const hotelID = hotel.Hotel_ID
        setNotscheduledemployees([])
        document.getElementById("AddCleanertoSchedule").innerHTML = ""
        const defaultoption = document.createElement("option");
        defaultoption.innerText = t('Add Employee')
        document.getElementById("AddCleanertoSchedule").appendChild(defaultoption)
        const updatedCleaners = {};
        const scheduled = hoteldata.plannedEMP[hotelID] || []
        let notscheduledCleaners = [];
        gethotelcleaners(hotelID).then(res => {
            if (res.status === 200) {
                res.json().then(data => {
                    data.items.forEach(employee => {

                        const schedule = scheduled.find(emp => emp.werknemer_Id === employee.id);
                        const isUnscheduled =
                            !schedule ||
                            (schedule.planned === 0);
                        if (isUnscheduled) {
                            const option = document.createElement("option");
                            option.key = Number(employee.id);
                            option.value = Number(employee.id)
                            option.innerText = employee.achternaam + ", " + employee.voornaam
                            document.getElementById("AddCleanertoSchedule").appendChild(option)
                        }
                    });

                    updatedCleaners[hotelID] = notscheduledCleaners;
                })
            } else {
                setErrorMessage(res.statusText)
                document.getElementById("FullscreenBlocker").style.display = "none";
            }
        });
        setNotscheduledemployees(notscheduledCleaners)
    }

    const handleSelectNewCleaner = (e, hotelid) => {
        var index = e.nativeEvent.target.selectedIndex;
        document.getElementById("CloseMessageButton").innerText = "Yes"
        document.getElementById("CancelMessageButton").innerText = "No"
        document.getElementById("CloseMessageButton").onclick = () => handleaddNewUser(e.target.value, hotelid, Moment(selectedroosterdate, 'YYYY-MM-DD').toDate())
        document.getElementById("CancelMessageButton").style.display = "grid"
        setMessage(t("areyousuretoadd") + e.nativeEvent.target[index].text + t("totheschedule"))
    }

    const BuildCleaningtypes = async (cleaningTypeDescription, assignmentcleaningtype) => {
        setcleaningtypes(cleaningTypeDescription)
        setcleaningtypesarray([]);
        let cleaningtypes = [];
        if (cleaningTypeDescription.length > 0) {
            cleaningTypeDescription.forEach(cleaningtype => {
                cleaningtypes.push(
                    <option key={cleaningtype.id} value={cleaningtype.id} selected={assignmentcleaningtype === cleaningtype.id ? true : false} >{optionstypes[cleaningtype.type] || "Type not recognised"} {cleaningtype.description}</option>
                )
            }
            )
        }
        cleaningtypes.push(
            <option key="-2" value="-2">{t('Specialrequest')}</option>
        )
        setcleaningtypesarray(cleaningtypes)
    }



    useEffect(() => {
        if (cleaningassignment && cleaningassignment.hotel_id) {
            buildPayedCleaningTasks(cleaningassignment.hotel_id, isAD);
        }
    }, [cleaningassignment.hotel_id, cleaningassignment, isAD]);

    const calculateExtraTasksDuration = async () => {

        cleaningtaskitems.map((item, index) => {
            if (Object.keys(extraTasksState).includes("" + item.Id)) {
                handleCheckboxChange(item.Id, index, Object.keys(extraTasksState).includes("" + item.Id), item, extraTasksState[item.Id])
                addmultipletotask(item.Id, item.taskDuration, extraTasksState[item.Id])
            }
        }
        )
    }

    useEffect(() => {

        const tempArray = (isAD ? cleaningtaskADitems : cleaningtaskitems).map((item, index) =>
        (
            <div className='checkboxrow doublegrid' key={item.Id} >
                <input
                    id={"interval" + item.Id}
                    type="checkbox"
                    checked={Object.keys(extraTasksState).includes("" + item.Id)}
                    name={item.Id}
                    value={item.taskDuration}
                    className="checkbox"
                    onChange={(e) => handleCheckboxChange(item.Id, index, e.target.checked, item)}
                    disabled={assignmentDisabled}
                />
                <label className='labelhotel leftalign'>
                    {item.taskDescription}
                </label>
                <input value={extraTasksState[item.Id] !== undefined ? extraTasksState[item.Id] : 1} id={"multiple" + item.Id} onChange={(e) => addmultipletotask(item.Id, item.taskDuration, e.target.value)} type="number" className="gridinputsmall" disabled={assignmentDisabled} min="1" />
            </div>
        )


        );

        if (isAD) {
            setcleaningtaskADarray(tempArray);
        } else {
            setcleaningtaskarray(tempArray);
        }

    }, [cleaningtaskitems, cleaningtaskADitems, extraTasksState, isAD, assignmentDisabled]);


    const addmultipletotask = (taskid, taskDuration, value) => {

        const checked = document.getElementById("interval" + taskid).checked
        const task = extraTasksState[taskid];
          console.log("value ", value)
        const originalDuration = taskDuration;
        const multiple = Number(value) || 0;
        const newDuration = originalDuration / multiple;
        console.log("taskDuration ", taskDuration)
        console.log("newDuration ", newDuration)
        console.log("task ", task)

        setExtraTasksStateDuration(prev => ({
            ...prev,
            [taskid]: newDuration
        }));

        // setExtraTasksState(prev => ({
        //     ...prev,
        //     [taskid]: multiple,
        // }));

         setExtraTasksState(prev => {
            const newTasks = { ...prev };
            if (checked) {
                newTasks[taskid] = value;
            } else {
                delete newTasks[taskid];
            }
            return newTasks;
        });
        

    };

    const buildPayedCleaningTasks = async (hotelid, adMode) => {
        if (!hotelid) return;
        const response = adMode ? await getCleaningADtasks(hotelid) : await getCleaningtasks(hotelid, 0);
        if (response.status === 200) {
            const body = await response.json();
            if (body.items) {

                if (adMode) {
                    setCleaningtaskADitems(body.items);
                } else {
                    setCleaningtaskitems(body.items);
                }
            }
        }
    };
    const ShowFocusOfftheDay = (HotelId) => {
        setSelectedhotel(HotelId)
        document.getElementById("focusOftheDay").style.display = "block";
        document.getElementById("coverAll").style.display = "block";
    }
    const nocleaning = (e, hotelid) => {
        if (document.getElementById(hotelid + "_Roomtab") !== null && e.target.checked !== undefined) {
            if (e.target.checked)
                document.getElementById(hotelid + "_Roomtab").style.display = "none";
            else
                document.getElementById(hotelid + "_Roomtab").style.display = "block";
        }
    }
    //nocleaning

    const selectCleaner = (employee_id, HotelId, kamers, assignments) => {
        ////////console.log("kamers:", kamers)

        ////////console.log("kamers:", kamers)
        //hotel, cleaners, assignments, employee_id, noCleaning, notscheduledemployees, kamers
        buildtabcontent(SelectedhotelObject, assignments.plannedEMP, assignments, employee_id, false, notscheduledemployees, kamers)
        selectrow("button_" + employee_id)
        setSelectedCleaner(employee_id);
        if (document.getElementById("details_" + employee_id).style.display === "none" || document.getElementById("details_" + employee_id).style.display === "")
            document.getElementById("details_" + employee_id).style.display = "block";
        else
            document.getElementById("details_" + employee_id).style.display = "none";
    }

    const selectrow = (rowid) => {
        if (prevCSS.current !== undefined && prevSelectedRecord.current !== undefined) {
            if (document.getElementById(prevSelectedRecord.current)) {
                document.getElementById(prevSelectedRecord.current).className = prevCSS.current;
            }
        }
        prevCSS.current = document.getElementById(rowid).className;
        prevSelectedRecord.current = rowid
        document.getElementById(rowid).className = "CleanerButton Add_border"

    }
    const GetScheduledCleaners = (scheduled, HotelId, kamers, assignments, employee_id) => {
        ////console.log("totalshotel :",totalshotel)
        document.getElementById("FullscreenBlocker").style.display = "block";
        document.getElementById("RotatinglinesText").innerText = "Ophalen gegevens even geduld"
        let scheduledCleaners = [];
        let totalhotelblijvers = 0;
        let totalhotelvertrekkers = 0;
        let totalhotelflits = 0;
        let totalhotelAD = 0;
        if (totalshotel.find(({ key }) => key === HotelId) !== undefined) {
            totalhotelblijvers = totalshotel.find(({ key }) => key === HotelId).data.blijver
        }
        if (totalshotel.find(({ key }) => key === HotelId) !== undefined) {
            totalhotelvertrekkers = totalshotel.find(({ key }) => key === HotelId).data.vertrekker
        }
        if (totalshotel.find(({ key }) => key === HotelId) !== undefined) {
            totalhotelflits = totalshotel.find(({ key }) => key === HotelId).data.flits
        }

        if (totalshotel.find(({ key }) => key === HotelId) !== undefined) {
            totalhotelAD = totalshotel.find(({ key }) => key === HotelId).data.AD
        }

        let totalbl = 0

        if (hotelblijvers.find(({ key }) => key === HotelId) !== undefined) {

            totalbl = hotelblijvers.find(({ key }) => key === HotelId).data.assignedvalue
        }
        let totalver = 0
        if (hotelvertrekkers.find(({ key }) => key === HotelId) !== undefined) {
            totalver = hotelvertrekkers.find(({ key }) => key === HotelId).data.assignedvalue
        }
        let totalflits = 0
        if (hotelflits.find(({ key }) => key === HotelId) !== undefined) {
            totalflits = hotelflits.find(({ key }) => key === HotelId).data.assignedvalue
        }
        let totalAD = 0
        if (hotelalgemenedienst.find(({ key }) => key === HotelId) !== undefined) {
            totalAD = hotelalgemenedienst.find(({ key }) => key === HotelId).data.assignedvalue
        }
        let totalSpecialRequests = 0
        if (hotelspecialrequest.find(({ key }) => key === HotelId) !== undefined) {
            totalSpecialRequests = hotelspecialrequest.find(({ key }) => key === HotelId).data.assignedvalue
        }

        scheduledCleaners.push(
            <div key={HotelId + "_focusoftheday"}>
                <div className='label' style={{ display: "none" }}>no cleaning today
                    <input id="noCleaning" className="checkbox" type='checkbox' onClick={(e) => nocleaning(e, HotelId)}></input>
                </div>
                <Button className="Aandachtspuntbutton" id={"button_" + HotelId} onClick={(e) => ShowFocusOfftheDay(HotelId)} style={{ display: "block" }}>
                    {t("AddGeneralTask")}
                </Button>
                <div id={"details_" + HotelId} className="scheduleRoosterGeneral">
                    {t("Blijvers")}:  {totalhotelblijvers} / {totalbl}
                    <br></br>
                    {t("Vertrekkers")}:  {totalhotelvertrekkers} / {totalver}
                    <br></br>
                    {t("flits")}:  {totalhotelflits} / {totalflits}
                    <br></br>
                    {t("Algemene dienst")}: {totalhotelAD} / {totalAD}
                    <br></br>
                    {t("Specialrequest")}: {totalhotelAD} / {totalSpecialRequests}
                </div>
            </div>
        )

        scheduled.forEach(employee => {
            if (employee.planned || employee.planned === true) {
                // const VM_startDate = Moment("2025-01-23T" + employee.VM_Beginuur);
                // const VM_timeEnd = Moment("2025-01-23T" + employee.VM_Einduur);
                // const VM_diff = VM_timeEnd.diff(VM_startDate);
                // const VM_diffDuration = Moment.duration(VM_diff);
                // const NM_startDate = Moment("2025-01-23T" + employee.NM_Beginuur);
                // const NM_timeEnd = Moment("2025-01-23T" + employee.NM_Einduur);
                // const NM_diff = NM_timeEnd.diff(NM_startDate);
                // const NM_diffDuration = Moment.duration(NM_diff);

                //let totalhoursassigned = getEmployeeTotal(employee.werknemer_Id)
                let blijversassigned = 0;
                let vertrekkersassigned = 0;
                let flitsassigned = 0;
                let ADassigned = 0

                assignments.assignments[HotelId].forEach(assignment => {
                    if (assignment.assignee_Id === employee.werknemer_Id && assignment.status !== 8) {
                        if (assignment.type === 1) {
                            vertrekkersassigned = vertrekkersassigned + 1
                        }
                        if (assignment.type === 0) {
                            blijversassigned = blijversassigned + 1
                        }
                        if (assignment.type === 2) {
                            flitsassigned = flitsassigned + 1
                        }
                    }
                }
                )
                assignments.defaults[HotelId].forEach(defaults => {
                    if (defaults.assignee_Id === employee.werknemer_Id) {
                        ADassigned = ADassigned + 1
                    }
                }
                )
                let totalscheduled = Number(employee.blijver, 0) + Number(employee.vertrekker, 0) + Number(employee.AD, 0)
                let totalassigned = vertrekkersassigned + blijversassigned + ADassigned
                let cssClass = "CleanerButton";
                let cssClassindicator = "cleanerschedulestatus";
                if (Number(totalassigned) === 0) {
                    cssClassindicator = "cleanerschedulestatus orange";
                } else if (Number(totalscheduled) < Number(totalassigned)) {
                    cssClassindicator = "cleanerschedulestatus blue";
                } else if (Number(totalscheduled) > Number(totalassigned)) {
                    cssClassindicator = "cleanerschedulestatus red";
                } else if (Number(totalscheduled) === Number(totalassigned)) {
                    cssClassindicator = "cleanerschedulestatus green";
                }
                if (employee_id !== undefined && employee_id === employee.werknemer_Id) {
                    cssClass = "CleanerButton Add_border"
                }
                //////console.log("employee :", employee)
                scheduledCleaners.push(
                    <div key={employee.werknemer_Id}>
                        <Button className={cssClass} id={"button_" + employee.werknemer_Id} onClick={() => selectCleaner(employee.werknemer_Id, HotelId, kamers, assignments)}>
                            <div className={cssClassindicator}></div> <BsFillMoonStarsFill style={employee.nightshift === 1 ? { visibility: 'visible' } : { visibility: 'hidden' }} className="cleanernighshift" /> {employee.achternaam.replace(/ /g, "\u00A0")},&nbsp;{employee.voornaam.replace(/ /g, "\u00A0")}
                        </Button>
                        <div id={"details_" + employee.werknemer_Id} className="scheduleUserDetails">
                            {/* Max uren:  {contracthours}
                            <br></br> */}
                            blijvers:  {employee.blijver} / {blijversassigned}
                            <br></br>
                            Vertrekkers:  {employee.vertrekker} / {vertrekkersassigned}
                            <br></br>
                            AD:  {employee.AD} / {ADassigned}

                        </div>
                    </div>
                );
            }

        });
        if (scheduledCleaners.length === 0) {
            scheduledCleaners.push(
                <div className="NoRoomsLinked" key={HotelId + "_noschedule"}><center>
                    {t("error_noscheduleforthishotel")}
                </center>
                </div>)
        }
        document.getElementById("FullscreenBlocker").style.display = "none";
        return scheduledCleaners
    }

    const GetHotelCleaners = async (HotelId, plannedEMP) => {
        if (HotelId) {
            await gethotelcleaners(HotelId).then(async res => {
                if (res.status === 200) {
                    await res.json().then(res => {
                        sethotelcleaners(res.items)
                        sethotelcleanersarray([]);
                        if (plannedEMP[HotelId].length > 0) {
                            plannedEMP[HotelId].forEach((employee, index) => {
                                if (employee.planned || employee.planned === true) {
                                    sethotelcleanersarray(pre => [...pre,
                                    <option key={employee.werknemer_Id} value={employee.werknemer_Id}>
                                        {employee.achternaam}, {employee.voornaam}
                                    </option>
                                    ])
                                }
                            })
                        }
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        }
    }

    const CreateDefaultCleaningassignment = async (hotel_Id, roomassignment, plannedEMP) => {
        document.getElementById("FullscreenBlocker").style.display = "Block";
        document.getElementById("RotatinglinesText").innerText = "Algemene diensttaak wordt aangemaakt, even geduld"
        ////console.log("hotel_Id :", hotel_Id)
        setIsAD(true);
        setSelectedhotel(hotel_Id)
        setassignmentDisabled(false);
        setExtraTasksState({});  // ✅ Clear immediately at start
        let date = selectedroosterdate
        //console.log(document.getElementById("selectedDateforTasks"))
        if (document.getElementById("selectedDateforTasks") !== undefined && document.getElementById("selectedDateforTasks").value !== date) {
            date = document.getElementById("selectedDateforTasks").value
        }
        if (roomassignment === undefined) {
            document.getElementById("DefaultupdateButton").style.display = "none";
            document.getElementById("DefaultEditButton").style.display = "none";
            document.getElementById("DefaultsaveButton").style.display = "block";
            document.getElementById("DefaultdeleteButton").style.display = "none";
            await setCleaningassignment({
                tasks: "",
                hotel_id: hotel_Id,
                id: "",
                cleaningtype_Id: -1,
                extratime: -1,
                roomnumber: "default cleaningassignment",
                extradescription: sessionStorage.getItem('FocusOfTheDay_' + hotel_Id + "_" + date),
                timeneeded: 0,
                status: 0,
                assignee_Id: -1,
                description: sessionStorage.getItem('FocusOfTheDay_' + hotel_Id + "_" + date),
                title: ""
            });

        } else {
            document.getElementById("DefaultupdateButton").style.display = "none";
            document.getElementById("DefaultsaveButton").style.display = "none";
            if (roomassignment.status > 0) {
                document.getElementById("DefaultdeleteButton").style.display = "none";
            } else {
                document.getElementById("DefaultdeleteButton").style.display = "block";
            }

            await setCleaningassignment(roomassignment);
            setassignmentDisabled(true);

            let tasksobj = {};
            if (roomassignment.multiple !== "{}") {

                let multipletasks = JSON.parse(roomassignment.multiple)

                const filteredkeys = Object.keys(multipletasks)
                filteredkeys.forEach((key) => {
                    tasksobj[key] = Number(multipletasks[key]);
                })
            }
            else
                if (roomassignment.tasks) {
                    roomassignment.tasks.split(",").forEach(task => {
                        tasksobj[task] = 0;
                    });
                }
            setExtraTasksState(tasksobj);  // ✅ Refill with selected tasks
        }
        await GetHotelCleaners(hotel_Id, plannedEMP);
        await buildPayedCleaningTasks(hotel_Id, true);  // ✅ Notice: true = for AD tasks!
        document.getElementById("Defaultassignmentdetails").style.display = "block";
        document.getElementById("coverAll").style.display = "block";
        document.getElementById("FullscreenBlocker").style.display = "none";
    }


    const Createcleaningassignment = async (kamer, hotel_Id, roomassignment, plannedEMP) => {
        document.getElementById("FullscreenBlocker").style.display = "Block";
        document.getElementById("RotatinglinesText").innerText = "Ophalen gegevens, even geduld"
        let date = selectedroosterdate
        if (document.getElementById("selectedDateforTasks") !== undefined && document.getElementById("selectedDateforTasks").value !== date) {
            date = document.getElementById("selectedDateforTasks").value
        }
        let focusmessage = "";
        if (sessionStorage.getItem('FocusOfTheDay_' + hotel_Id + "_" + date) !== null) {
            focusmessage = sessionStorage.getItem('FocusOfTheDay_' + hotel_Id + "_" + date)
        }
        setSelectedhotel(hotel_Id)
        setIsAD(false);
        setassignmentDisabled(false);
        setExtraTasksState({});
        console.log(roomassignment)

        if (roomassignment === undefined) {
            // NEW ASSIGNMENT
            document.getElementById("updateButton").style.display = "none";
            document.getElementById("saveButton").style.display = "block";
            document.getElementById("EditButton").style.display = "none";     // <--- Hide Edit
            document.getElementById("deleteButton").style.display = "none";

            await setCleaningassignment({
                hotel_id: hotel_Id,
                id: null,
                cleaningtype_Id: -1,
                roomnumber: kamer.kamerNummer,
                extradescription: focusmessage,
                extratime: 0,
                status: 0,
                assignee_Id: -1,
                description: "",
                tasks: ""
            });

        } else {
            // EXISTING ASSIGNMENT (EDIT MODE)
            document.getElementById("updateButton").style.display = "none";
            document.getElementById("saveButton").style.display = "none";
            document.getElementById("EditButton").style.display = "block";    // <--- Show Edit

            if (roomassignment.status > 0) {
                document.getElementById("deleteButton").style.display = "none";
            } else {
                document.getElementById("deleteButton").style.display = "block";
            }

            await setCleaningassignment(roomassignment);
            setassignmentDisabled(true);

            let tasksobj = {};
            if (roomassignment.multiple !== "{}" && roomassignment.multiple !== null) {

                let multipletasks = JSON.parse(roomassignment.multiple)

                const filteredkeys = Object.keys(multipletasks)
                filteredkeys.forEach((key) => {
                    tasksobj[key] = Number(multipletasks[key]);
                })

                //await FillExtraTaskDurationState(tasksobj)
            }
            else if (roomassignment.tasks) {
                roomassignment.tasks.split(",").forEach(task => {
                    tasksobj[task] = 0;
                });
            }
            setExtraTasksState(tasksobj);
        }
        await BuildCleaningtypes(kamer.cleaningTypeDescription);
        await buildPayedCleaningTasks(hotel_Id, false);
        await setRoomsettings(kamer);
        //////////////console.log(plannedEMP)
        await GetHotelCleaners(hotel_Id, plannedEMP);

        document.getElementById("assignmentdetails").style.display = "block";
        document.getElementById("coverAll").style.display = "block";
        document.getElementById("FullscreenBlocker").style.display = "none";
    }
    function addDays(date, days) {
        const newDate = new Date(date);
        newDate.setDate(date.getDate() + days);
        return newDate;
    }

    const startdrag = (windowname, drag, e) => {
        setWindowtodrag(windowname)
        var rect = e.target.getBoundingClientRect();
        setleft(e.clientX - rect.left)
        settop(e.clientY - rect.top)
        setDragWindow(drag)
    }

    const MouseMove = (e) => {
        if (dragwindow === true && windowtodrag !== null) {
            document.getElementById(windowtodrag).style.zIndex = 250000
            document.getElementById(windowtodrag).style.top = (e.clientY - (10 - window.pageYOffset)) + "px"
            document.getElementById(windowtodrag).style.left = (e.clientX - (left - window.pageXOffset)) + "px"
        }
    }

    return (
        <>
            <div className="fullscreen" id="FullscreenBlocker">
                <div id="Rotatinglines" className="checkingatworkstatusmessage">
                    <center>
                        <RotatingLines
                            strokeColor="grey"
                            strokeWidth="5"
                            animationDuration="0.75"
                            visible={true} className="spinner"
                        />
                        <br></br>
                        <div id="RotatinglinesText">Gegevens worden verwerkt, even geduld aub</div>
                    </center>
                </div>
            </div>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText"></div><br></br>
                            <center>
                                <div className='messageBoxes'>
                                    <Button type="button" id="CloseMessageButton" className="OkCancel messageBoxAlignRight" onClick={clearMessage}>{t("OK")}</Button>
                                    <Button type="button" id="CancelMessageButton" className="OkCancel messageBoxAlignleft" onClick={clearMessage}>{t("Cancel")}</Button>
                                </div></center>
                        </div></div>

                </header>
                <div id="content">
                    <form className="form">
                        <div id="legend" className='legend'>
                            <div >
                                <p className='formtitle'>{t('Aanmaaktaken')} <span style={{ display: "none" }}>next day <input id="nextday" className="checkbox" type='checkbox'></input></span></p>
                            </div>
                            <div className={"CleaningTypeButton_status0 legendbutton"}>{t('assigned')}</div>
                            <div className={"CleaningTypeButton_status6 legendbutton"}>{t('DND')}</div>
                            <div className={"CleaningTypeButton_status1 legendbutton"}>{t('started')}</div>
                            <div className={"CleaningTypeButton_status2 legendbutton"}>{t('QAcontroled')}</div>
                            <div className={"CleaningTypeButton_status3 legendbutton"}>{t('readyforQA')}</div>
                            <div className={"CleaningTypeButton_status4 legendbutton"}>{t('Issuereported')}</div>
                            <div className={"CleaningTypeButton_status5 legendbutton"}>{t('Rework')}</div>
                            <div className={"CleaningTypeButton_status7 legendbutton"}>{t('RedoStarted')} </div>
                            <div className={"CleaningTypeButton_status8 legendbutton"}>{t('Deleted')} </div>
                        </div>
                        <div id="searchboxdate" className="formElement">
                            <label className='labelcolor'>
                                {t('Date')}:
                            </label>
                            <input className='date' type="date" id="selectedDateforTasks" defaultValue={addDays(new Date(), 0).toLocaleDateString('en-CA')} onChange={rebuildTabs} min={addDays(new Date(), -2).toLocaleDateString('en-CA')} max={addDays(new Date(), 1).toLocaleDateString('en-CA')}></input>
                        </div>

                        <Tabs className="HotelTabs" id="taboverview" selectedIndex={selectedtab} onSelect={false}>
                            <TabList id="tablisthoteloverview">
                                {tabs}
                            </TabList>
                            {tabpanelscontent}
                        </Tabs>
                        <div className='legendfooter'>
                            <div className="cleanerschedulestatus green"></div><p className='labelfooter'>Assigned = scheduled </p>
                            {/* <div className="cleanerschedulestatus"></div><p className='labelfooter'>Contracted &gt; Assigned </p> */}
                            <div className="cleanerschedulestatus blue"></div><p className='labelfooter'>Scheduled   &lt; assigned </p>
                            <div className="cleanerschedulestatus red"></div><p className='labelfooter'>Assigned  &gt; scheduled</p>
                            <div className="cleanerschedulestatus orange"></div><p className='labelfooter'>Nothing assigned</p>
                        </div>
                    </form>
                </div>
                <div id="coverAll" className="subscreen" onMouseMove={MouseMove}>
                    <AssignmentDetail
                        rights={props.rights}
                        t={props.translation}
                        isDisabled={assignmentDisabled}
                        hotelcleanersarray={hotelcleanersarray}
                        cleaningtypesarray={cleaningtypesarray}
                        cleaningtaskarray={cleaningtaskarray}
                        data={{ cleaningassignment: cleaningassignment, roomsettings: roomsettings }}
                        events={{
                            handleCancel: handleCancel,
                            handleOnchange: handleOnchange,
                            handleChangecheckbox: handleChangecheckbox,
                            showAssignedCleaningTasks: showAssignedCleaningTasks,
                            handlDeleteAssignment: handlDeleteAssignment,
                            handlEditAssignment: handlEditAssignment,
                            handlUpdateAssignment: handlUpdateAssignment,
                            handlCreateAssignment: handlCreateAssignment,
                            startdrag: startdrag,
                            handleFocusOfftheday: handleFocusOfftheday,
                            ReSetAssignment: ReSetAssignment
                        }}
                        hotelid={Selectedhotel}
                        date={selectedroosterdate}
                    />
                    <DefaultAssignmentDetail
                        rights={props.rights}
                        t={props.translation}
                        isDisabled={assignmentDisabled}
                        hotelcleanersarray={hotelcleanersarray}
                        cleaningtypesarray={cleaningtypesarray}
                        cleaningtaskADarray={cleaningtaskADarray}
                        data={{ cleaningassignment: cleaningassignment, roomsettings: roomsettings }}
                        events={{
                            handleCancel: handleCancel,
                            handleOnchange: handleOnchange,
                            showAssignedCleaningTasks: showAssignedCleaningTasks,
                            handlDeleteAssignment: handlDeleteAssignment,
                            handlEditDefaultAssignment: handlEditDefaultAssignment,
                            handlUpdateDefaultAssignment: handlUpdateDefaultAssignment,
                            handlCreateDefaultAssignment: handlCreateDefaultAssignment,
                            startdrag: startdrag

                        }}
                        hotelid={Selectedhotel}
                        date={selectedroosterdate}
                    />
                    <FocusOfTheDay
                        rights={props.rights}
                        t={props.translation}
                        hotelid={Selectedhotel}
                        date={selectedroosterdate}
                        events={{
                            handleCancel: handleCancel,
                            startdrag: startdrag

                        }}
                    />
                    <DeleteReason
                        rights={props.rights}
                        t={props.translation}
                        hotelid={Selectedhotel}
                        cleaningassignment={cleaningassignment}
                        events={{
                            handleCancel: handleCancel,
                            handleOnchange: handleOnchange,
                            startdrag: startdrag,
                            HandleDelete: handleDeleteAssignmentafterstartup
                        }}
                    />
                </div>
            </div>

        </>
    )

}

export default AssignCleaningTasks